export const khachHang = {
  sections: {
    list: { title: 'Customers' },
    general: 'General',
    address: 'Address',
    groupNote: 'Customer group & note',
    invoiceExport: 'Invoicing information',
    extra: 'Additional information',
    invoice: 'Invoice & tax',
    idDocs: 'ID documents',
    bank: 'Bank',
    meta: 'Statistics',
    tabGeneral: 'General',
    tabDiaChiNhanHang: 'Delivery info',
    tabThongTinXuatHoaDon: 'Invoicing information',
  },
  fields: {
    code: 'Customer code',
    name: 'Customer name',
    phone1: 'Phone 1',
    phone2: 'Phone 2',
    birthday: 'Date of birth',
    gender: 'Gender',
    email: 'Email',
    facebook: 'Facebook',
    address: 'Address',
    province: 'Province/City',
    area: 'Area',
    ward: 'Ward/Commune',
    note: 'Note',
    customerType: 'Customer type',
    groups: 'Groups',
    groupCode: 'Group code',
    groupName: 'Group name',
    nhanVienPhuTrach: 'Sales rep',
    maNhanVienPhuTrach: 'Sales rep code',
    dinhMucCongNo: 'Credit limit',
    ngayCanDoiNo: 'Collection date',
    ngayDoiNoCuThe: 'Pick a date',
    ngayDoiNoHangThang: 'Day of month',
    buyerName: 'Buyer (invoice)',
    taxCode: 'Tax code',
    invoiceAddress: 'Invoice address',
    invoiceProvince: 'Invoice province',
    invoiceWard: 'Invoice ward',
    invoiceEmail: 'Invoice email',
    invoicePhone: 'Invoice phone',
    citizenId: 'Citizen ID',
    passport: 'Passport',
    bankName: 'Bank',
    bankAccount: 'Account number',
    status: 'Status',
    totalSales: 'Total sales',
    totalSalesNet: 'Sales net of returns',
    debt: 'Current debt',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    actions: 'Actions',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  loai: { caNhan: 'Individual', congTy: 'Organization / business household' },
  placeholders: {
    codeAuto: 'KH0000001',
    email: 'email@gmail.com',
    facebook: 'facebook.com/username',
    address: 'Enter address',
    area: 'Select province/city',
    ward: 'Select ward/commune',
    groups: 'Select customer group',
    note: 'Enter note',
    nhanVienPhuTrach: 'Select sales rep',
    maNhanVienPhuTrach: 'Enter sales rep code',
    dinhMucCongNo: 'Empty = no limit',
    ngayCanDoiNo: 'Warn to collect if still owing on this date',
    ngayDoiNoHangThang: 'Warn every month from this day if still owing; short months use the last day',
    ngayDoiNoHangThangChon: 'Select day',
    gender: 'Select gender',
    buyerName: 'Enter buyer name',
    taxCode: 'Enter tax code',
  },
  avatar: {
    addPhoto: 'Add photo',
    maxSize: 'Image must not exceed 2MB',
    chooseImage: 'Choose image',
    pasteImage: 'Paste image',
    pasteHint: 'Ctrl+V in the frame or click Paste image',
    pasteNoImage: 'No image in clipboard. Copy an image or paste an http(s) link.',
    uploading: 'Uploading image…',
  },
  formActions: {
    lookupTax: 'Look up tax ID',
    lookupTaxSoon: 'Tax ID lookup will be available soon',
  },
  actions: {
    addDiaChi: 'Add',
    addTtxhd: 'Add company',
  },
  values: {
    khongGioiHan: 'No limit',
    chuaDat: 'Not set',
    hangThang: 'Day {day} of every month',
    ngayTrongThang: 'Day {day}',
  },
  kieuHanDoiNo: { khong: 'Not set', hangThang: 'Monthly', ngay: 'Specific date' },
  gender: { nam: 'Male', nu: 'Female' },
  status: {
    dangHoatDong: 'Active',
    ngungHoatDong: 'Inactive',
    all: 'All',
  },
  sort: {
    maKhachHang: 'Code',
    tenKhachHang: 'Name',
    ngayTao: 'Created',
    trangThai: 'Status',
    noHienTai: 'Debt',
    tongBan: 'Sales',
  },
  filter: {
    searchPlaceholder: 'Search',
    textDetailTitle: 'Detail filters',
    group: 'Group',
    statusSection: 'Status',
    groupSection: 'Customer group',
    loaiSection: 'Customer type',
    debtSection: 'Receivables status',
    debtAll: 'All',
    debtOutstanding: 'Outstanding (≠ 0)',
    debtCleared: 'Cleared (= 0)',
    genderSection: 'Gender',
    khuVucSection: 'Area',
    khuVucPlaceholder: 'Area (province/city)',
    sortSection: 'Sort',
    sortField: 'Sort by',
    sortDir: 'Direction',
  },
  titles: { add: 'Add customer', edit: 'Edit customer', detail: 'Customer detail' },
  validation: {
    nameRequired: 'Please enter customer name',
    hanDoiNoRequired: 'Please select the collection day',
    phoneInvalid: 'Invalid phone number (8–15 digits)',
    emailInvalid: 'Invalid email',
    emailHoaDonInvalid: 'Invalid invoice email (separate multiple with ;)',
    dinhMucCongNoAm: 'Debt limit cannot be negative',
    phoneInvalidField: '{field} is invalid (8–15 digits)',
    birthdayInvalid: 'Invalid birthday (cannot be in the future or before 1900)',
    viDoInvalid: 'Latitude must be between -90 and 90',
    kinhDoInvalid: 'Longitude must be between -180 and 180',
    taxCodeInvalid: 'Invalid tax code (10 or 13 digits)',
    companyNameRequired: 'Please enter the invoice company name',
    subFormInvalid: 'Delivery / invoice information has invalid fields',
    trungSdtTitle: 'Phone number already exists',
    trungSdtMessage: 'Phone {phone} is already used by: {customers}. Save this customer anyway?',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load data',
    loadDetailError: 'Failed to load detail',
    createSuccess: 'Customer created',
    updateSuccess: 'Customer updated',
    deleteSuccess: 'Customer deleted',
    toggleSuccess: 'Status updated',
    confirmDelete: 'Delete customer «{name}»?',
    confirmTitle: 'Confirm delete',
    listSummary: 'Total {count} customers',
    selectedCount: 'Selected: {count}',
    deleteSelected: 'Delete selected ({count})',
    bulkDeleteConfirm:
      'Delete {count} selected customer(s)? (Each customer is deleted via a separate API call.)',
    bulkDeleteSuccess: 'Deleted {count} customer(s)',
    bulkDeletePartial: 'Deleted {ok}/{total}. {failed} could not be deleted.',
    bulkDeleteError: 'Bulk delete failed',
    bulkDeleteNoneSelected: 'No customers selected',
  },
  import: {
    description:
      'Download the multi-sheet Excel template: Customers, Delivery info, Tax companies, Bank accounts (+ reference sheets). Fill it in and upload to import.',
    success: 'Customers imported successfully',
    failed: 'Customer import failed',
    noData: 'The file has no valid data rows',
    noSheet: 'The Excel file has no sheets',
    wrongTemplate:
      'This is not a customer import template (e.g. a product template was selected). Download the template from this dialog, or import products from the Products menu.',
    sheetsHint:
      'Data: Customers · Delivery info · Tax companies · Bank accounts. Reference: Customer groups · Staff · Banks · Gender · Guide.',
    menu: {
      kh: 'Import customers',
      diaChi: 'Import delivery info',
      cty: 'Import tax companies',
      taiKhoan: 'Import bank accounts',
      toHop: 'Combined import (KH + delivery + CTY + accounts)',
    },
    modes: {
      kh: {
        title: 'Import customers',
        description: 'Download the Customers sheet template. Does not create addresses / tax companies / accounts.',
        success: 'Customers imported successfully',
      },
      diaChi: {
        title: 'Import delivery info',
        description: 'Customer code must already exist. One row = one delivery address.',
        success: 'Delivery info imported successfully',
      },
      cty: {
        title: 'Import tax companies',
        description: 'Customer code must already exist. One row = one tax / invoice company (no bank accounts).',
        success: 'Tax companies imported successfully',
      },
      taiKhoan: {
        title: 'Import bank accounts',
        description: 'Attach accounts by tax code / company name already on the customer.',
        success: 'Bank accounts imported successfully',
      },
      ctyTaiKhoan: {
        title: 'Import tax companies + bank accounts',
        description:
          'Two sheets: Tax companies and Bank accounts. Customer code must already exist. Accounts link by tax code / company name.',
        success: 'Companies + accounts imported successfully',
      },
      toHop: {
        title: 'Combined import',
        description:
          'Multi-sheet template: Customers · Delivery info · Tax companies · Bank accounts (+ reference sheets). Creates new customers with related data.',
        success: 'Combined import succeeded',
      },
    },
  },
  detailTabs: {
    generalInfo: 'Info',
    diaChiLayHang: 'Delivery info',
    thongTinXuatHoaDon: 'Invoice companies',
    debt: 'Receivables',
    salesReturnHistory: 'Sales / return history',
    orderHistory: 'Order history',
  },
  expandSalesReturn: {
    hint: 'Sales / return history will appear here.',
  },
  expandOrderHistory: {
    hint: 'Order history will appear here.',
  },
  expandDebt: {
    hint: 'Debt transaction history will appear here.',
    loading: 'Loading receivables…',
    loadError: 'Failed to load receivables',
    totalDue: 'Total receivable',
    totalPaid: 'Paid',
    totalRemaining: 'Outstanding',
    invoiceCount: '{count} invoices',
    recentInvoices: 'Recent invoices',
    viewAll: 'View all',
    retry: 'Retry',
    invoiceCode: 'Invoice code',
    invoiceDate: 'Date',
    invoiceStatus: 'Status',
    amountDue: 'Receivable',
    amountPaid: 'Paid',
    amountRemaining: 'Remaining',
  },
}
